import React, { useEffect, useState, lazy } from 'react';
import { connect } from 'react-redux';
import CloseIcon from '@vds/icons/close';
import './css/Allpackage.css';
import ChannelModal from './ChannelModal';
import { getPackageByName } from './actions/action';
import { Table, TableHead, TableBody, TableHeader, TableRow, Cell } from '@vds/tables';
import { Button } from '@vds/buttons';
//import images from './images/loading-large.png';

const Image = lazy(() => import('./ImageComponent'));

function Allpackage(props) {
    const [allPackage, setAllPackage] = useState([]);
    const [channelAvail, setChannelAvail] = useState([]);
    const [displayHeader, setdisplayHeader] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [active, setActive] = useState(false);
    const [channelAvail2, setChannelAvail2] = useState([]);
    const [packageSelected, setPackageSelected] = useState([]);
    const [channelList, setChannelList] = useState([]);
    const queryUrl = window.location.href;
    const searchValue = queryUrl?.split('?')[1];
    const searchParam = new URLSearchParams(searchValue);
    const appID = searchParam.get('appid') || 'consumer';

    useEffect(() => {
        const fezip = window.sessionStorage.getItem("fezip") || '';
        if (props?.allPackageData?.masterpackagesview?.length > 0) {
            window.sessionStorage.setItem(`consumer${fezip}${props.ifa}`, (JSON.stringify(props?.allPackageData)))
            setAllPackage(props?.allPackageData?.masterpackagesview);
        }
        const selectedRegion = JSON.parse(window.sessionStorage.getItem(`consumer${fezip}${props.ifa}`)) || '';
        if (selectedRegion?.masterpackagesview?.length > 0) {
            setAllPackage(selectedRegion?.masterpackagesview);
        }
    }, [props?.allPackageData]);

    useEffect(() => {
        if (props?.compareData?.length > 0) {
            setChannelAvail(channelAvail => [...channelAvail, props.searchChannelCount]);
            setChannelAvail2(props.compareData);
            setdisplayHeader(true);
            setActive(true);
            const fezip = window.sessionStorage.getItem("fezip") || '';
            if (fezip != '') {
                window.sessionStorage.setItem("searchedArray", JSON.stringify(props.compareData));
            }
        } else {
            setChannelAvail([]);
        }
    }, [props.compareData]);
    useEffect(() => {
        props?.serachedChannelCount(channelAvail2);
        const packSelected = JSON.parse(window.sessionStorage.getItem("PackageSelected")) || '';
        const selectedChannelList = JSON.parse(window.sessionStorage.getItem("channelList")) || '';
        setTimeout(() => {
            if (packSelected.length > 0) {
                packSelected.map((item) => {
                    if (document.getElementById(item.packageusoc) !== null) {
                        document.getElementById(item.packageusoc).style.border = "2px solid black";
                    }
                })
                setPackageSelected(packSelected);
                            }
            if (selectedChannelList.length > 0) {
                setChannelList(selectedChannelList);
                setShowModal(true);
                props.compareChannelClicked(true);
            }
         }, 200)
    }, [channelAvail2])


    const closeChannelAvail = (data, dCount) => {
        //console.log("datains",data);
        const x = channelAvail2.splice(data, 1);
        if (channelAvail2.length == 0) {
            setdisplayHeader(false);
        }
        setChannelAvail(channelAvail2 => [...channelAvail2]);
        window.sessionStorage.setItem("searchedArray", JSON.stringify(channelAvail2));
        //console.log("searched data",channelAvail2)
        props.serachedChannelCount(channelAvail2);
    }
    const showButtonHandler = (data, index) => {
        if (packageSelected.find(({ packageusoc }) => packageusoc === data.packageusoc)) {
            packageSelected.map((item, index) => {
                if (item.packageusoc == data.packageusoc) {
                    document.getElementById(data.packageusoc).style.border = "none";
                    packageSelected.splice(index, 1);
                    setPackageSelected(packageSelected => [...packageSelected]);
                    window.sessionStorage.setItem("PackageSelected", JSON.stringify(packageSelected));
                }
            })
        }
        else {
            if (packageSelected.length > 1) {
                document.getElementById(data.packageusoc).style.border = "none";
            }
            else {
                document.getElementById(data.packageusoc).style.border = "2px solid black";
                setPackageSelected(packageSelected => [...packageSelected, data]);
            }
        }
        // if(packageSelected.length < 2){
        //     if(packageSelected == ''){
        //         document.getElementById(data.packageusoc).style.border="2px solid black";
        //         setPackageSelected(packageSelected =>[...packageSelected, data]);
        //     }
        //     if(packageSelected.length == 1){
        //         if(data.packageusoc != packageSelected[0].packageusoc){
        //             document.getElementById(data.packageusoc).style.border="2px solid black";
        //             setPackageSelected(packageSelected =>[...packageSelected, data]);
        //         }
        //     }
        // }
    }

    useEffect(() => {
        if(packageSelected.length > 0){
            window.sessionStorage.setItem("PackageSelected", JSON.stringify(packageSelected));
        }
    }, [packageSelected])

    function enableBackButton() {
        setShowModal(false);
        setTimeout(()=>{
        if (packageSelected.length > 0) {
            packageSelected.map((item) => {
                if (document.getElementById(item.packageusoc) !== null) {
                    document.getElementById(item.packageusoc).style.border = "2px solid black";
                }
            })
        }
        },100)
        props.compareChannelClicked(false);
        setChannelList([]);
        window.sessionStorage.removeItem("channelList")
    }

    const packageViewByName = () => {
        const packageId = packageSelected.length == 1 ? packageSelected[0].packageusoc : packageSelected[0].packageusoc + ',' + packageSelected[1].packageusoc;
        let payload = {
            appid: appID,
            lfa: props.ifa,
            packageid: packageId,
            vhoname: (window.sessionStorage.getItem("vhoname") || "BURLINGTON MA"),
            visitid: (window.localStorage.getItem("visit_id") || ''),
            visitorid: (window.localStorage.getItem("visitor_id") || '')
        }
        getPackageByName(props.dispatch, payload);
    }
    useEffect(() => {
        //console.log("packageSelected",packageSelected);
        if (packageSelected.length > 0) {
            if (props?.packageViewByNameData) {
                (props?.packageViewByNameData?.channesnameview).map((item) => {
                    channelList.push(item.channelist)
                })
                setShowModal(true);
                props.compareChannelClicked(true);
                const channelListSelect = JSON.parse(window.sessionStorage.getItem("channelList")) || '';
                if (channelListSelect == '') {
                    window.sessionStorage.setItem("channelList", JSON.stringify(channelList));
                }
            }
        }
    }, [props?.packageViewByNameData]);

    //function to check whether image exist in folder or not
    // function CheckImage(path) {
    //     try {
    //         let urlImg = <LazyLoadImage>{require(`./images/${path}`).default}</LazyLoadImage>
    //         // console.log("imgurl",urlImg)
    //         return true;
    //     }
    //     catch (error) {
    //         return false;
    //     }
    // }

    const LoadImage = (element) =>{
        const images = <Image element={element.channellogourl}/>
        return images;
    }

    return (
        <>
            <div className={`${channelAvail2.length == 4 ? "selectPackageContainer4" : "selectPackageContainer"}`}>
                <div className='selectPackageContentContainer'>
                    {!showModal &&
                    <div className='selectContentContainer'>

                        {/* <div className={`selectPackageRow marginSearch${channelAvail2.length}`}  style= {{width: `calc(100vw/${channelAvail2.length+1})`}}> */}
                        <div className={`selectPackageRow marginSearch${channelAvail2.length}`} >
                            {<Table
                                striped={false}
                                surface="light"
                                padding="compact"
                                headerBottomLine="primary"
                                rowBottomLine="secondary"
                            >
                                {props.channelCompare && <TableHead className="tablehead">
                                    {displayHeader && <TableHeader className="tableHeading"
                                        style={{ width: `calc(100%/${channelAvail2.length + 1})` }}>
                                        All packages
                                    </TableHeader>}
                                    {channelAvail2.map((data, index) => {
                                        // const img=data.channellogourl;

                                        return (<TableHeader className="tableHeading2" key={index}>
                                            <div className='tableHeaderContainer'>
                                                {/* <img className="tableImage" src={data.channellogourl ? `https://www.verizon.com/content/dam/verizon/personal/cluimages/${data.channellogourl}` : 'https://www.verizon.com/content/dam/verizon/personal/atom/loading-large.png'} /> */}
                                                {/* <img className="tableImage" src={data.channellogourl ? require( `./images/${data.channellogourl}`).default :  images} alt="unable to display" /> */}
                                                {/* <LazyLoadImage>
                                                <img alt='image' fetchPriority='low' decoding='async' role="presentation" loading="lazy" className="tableImage" src={CheckImage(data.channellogourl) ? require(`./images/${data.channellogourl}`).default : images} />
                                                </LazyLoadImage> */}
                                                {LoadImage(data)}
                                                <button data-testid="closeSearch" className="tableButton" onClick={() => closeChannelAvail(index, data.count)}>
                                                    <span className={`closeSearch${channelAvail2.length}`}>
                                                        <CloseIcon
                                                            size="small"
                                                            color="#000000"
                                                        /></span>
                                                </button>
                                            </div>
                                        </TableHeader>)
                                    })}
                                </TableHead>}
                                <TableBody>
                                    {allPackage.map((value, index) => {
                                        return ((<div key={index} data-testid={`package-select${value.packageusoc}`} onClick={() => showButtonHandler(value)} className="tableRow">
                                            <TableRow key={index} tabIndex={index} id={value.packageusoc}
                                            >
                                                <Cell>
                                                    <p className="packageName">{value.packagename.replace('&amp;','&')}</p>
                                                    <p className="packageChannel">{value.totalchannelcount}+ channels</p>
                                                </Cell>

                                                {props.channelCompare && channelAvail2.map((data, index) => {
                                                    return (
                                                        <Cell key={index}>
                                                            {data.ispriemum == 'N' &&
                                                                <p className="packageIcon">
                                                                    {(data.packagelist.split(',')).includes(value.packageusoc) ?
                                                                        <span className='dotsign'></span>
                                                                        : ''}</p>
                                                            }
                                                            {data.ispriemum == 'Y' &&
                                                                <p className="packageIcon"><b>$</b></p>
                                                            }
                                                        </Cell>)
                                                })
                                                }
                                            </TableRow>
                                        </div>
                                        ))
                                    })
                                    }
                                </TableBody>

                            </Table>
                            }
                        </div>
                        {
                            packageSelected.length == 1 &&
                            <Button size="large"
                                disabled={false}
                                use="primary"
                                className={`viewBtn btnshowLineup btnshowup${channelAvail2.length}`}
                                onClick={packageViewByName}
                            >
                                View All Channels
                            </Button>
                        }
                        {
                            packageSelected.length == 2 &&
                            <Button size="large"
                                disabled={false}
                                use="primary"
                                className={`viewBtn btnshowLineup btnshowup${channelAvail2.length}`}
                                onClick={packageViewByName}
                            >Compare Channels
                            </Button>
                        }
                    </div>
                    }
                    {
                        showModal &&
                        <div className='channelModal'>

                            <ChannelModal packageSelected={packageSelected} enableBackButton={enableBackButton} ifa={props.ifa}
                                channelList={channelList} />

                        </div>
                    }
                </div>
            </div>
        </>

    )
}

const mapStateToProps = (state) => {
    return {
        allPackageData: state.channelReducer.allPackageData,
        packageViewByNameData: state.channelReducer.packageViewByNameData
    }
}


export default React.memo(connect(mapStateToProps)(Allpackage));